// 返修配置
const repairConfig = [
  {
    path: '/product-category',
    name: 'productCategoryPage',
    meta: { tag: '产品分类' },
    component: () => import('@/pages/ProductCategoryPage')
  },
  {
    path: '/product-line',
    name: 'productLinePage',
    meta: { tag: '产品系列' },
    component: () => import('@/pages/ProductLinePage')
  },
  {
    path: '/product',
    name: 'productPage',
    meta: { tag: '产品' },
    component: () => import('@/pages/ProductPage')
  },
  {
    path: '/product-spec',
    name: 'productSpecPage',
    meta: { tag: '产品型号' },
    component: () => import('@/pages/ProductSpecPage')
  },
  {
    path: '/product-param',
    name: 'productParamPage',
    meta: { tag: '产品参数' },
    component: () => import('@/pages/ProductParamPage')
  },
  {
    path: '/product-project-code',
    name: 'productProjectCodePage',
    meta: { tag: '产品项目' },
    component: () => import('@/pages/productProjectCodePage')
  },
  {
    path: '/brand',
    name: 'brandPage',
    meta: { tag: '品牌' },
    component: () => import('@/pages/BrandPage')
  },
  {
    path: '/fee-reason',
    name: 'feeReasonPage',
    meta: { tag: '收费原因' },
    component: () => import('@/pages/FeeReasonPage')
  },
  {
    path: '/causes',
    name: 'causes',
    meta: { tag: '故障原因' },
    component: () => import('@/pages/Causes')
  },
  {
    path: '/fault',
    name: 'faultPage',
    meta: { tag: '故障' },
    component: () => import('@/pages/FaultPage')
  },
  {
    path: '/test-result-category',
    name: 'testResultCategoryPage',
    meta: { tag: '检测结果分类' },
    component: () => import('@/pages/TestResultCategoryPage')
  },
  {
    path: '/test-result',
    name: 'testResultPage',
    meta: { tag: '检测结果' },
    component: () => import('@/pages/TestResultPage')
  },
  {
    path: '/channel-type',
    name: 'channelTypePage',
    meta: { tag: '渠道类型' },
    component: () => import('@/pages/ChannelTypePage')
  },
  {
    path: '/channel',
    name: 'channelPage',
    meta: { tag: '渠道' },
    component: () => import('@/pages/ChannelPage')
  },
  {
    path: '/material-category',
    name: 'materialCategoryPage',
    meta: { tag: '物料分类' },
    component: () => import('@/pages/MaterialCategoryPage')
  },
  {
    path: '/material',
    name: 'materialPage',
    meta: { tag: '物料' },
    component: () => import('@/pages/MaterialPage')
  },
  {
    path: '/produce-factory',
    name: 'produceFactoryPage',
    meta: { tag: '生产工厂' },
    component: () => import('@/pages/ProduceFactoryPage')
  },
  {
    path: '/parts-cost',
    name: 'partsCostPage',
    meta: { tag: '维修价格' },
    component: () => import('@/pages/PartsCostPage')
  },
  {
    path: '/material-split-item',
    name: 'materialSplitItemPage',
    meta: { tag: '物料拆分配置' },
    component: () => import('@/pages/MaterialSplitItemPage')
  },
  {
    path: '/region',
    name: 'RegionPage',
    meta: { tag: '城市区域' },
    component: () => import('@/pages/RegionPage')
  },
  {
    path: '/give-type',
    name: 'giveTypePage',
    meta: { tag: '赠送类型' },
    component: () => import('@/pages/GiveTypePage')
  },
  {
    path: '/service-type',
    name: 'serviceTypePage',
    meta: { tag: '服务类型' },
    component: () => import('@/pages/ServiceTypePage')
  },
  {
    path: '/receive-type',
    name: 'receiveTypePage',
    meta: { tag: '受理类型' },
    component: () => import('@/pages/ReceiveTypePage')
  },
  {
    path: '/repair-method',
    name: 'repairMethodPage',
    meta: { tag: '维修方法' },
    component: () => import('@/pages/RepairMethodPage')
  },
  {
    path: '/agent-product',
    name: 'agentProductPage',
    meta: { tag: '销售运营产品配置' },
    component: () => import('@/pages/AgentProductPage')
  },
  {
    path: '/express-uce',
    name: 'expressUcePage',
    meta: { tag: '优速快递记录' },
    component: () => import('@/pages/ExpressUcePage')
  },
  {
    path: '/material-code-match',
    name: 'materialCodeMatchPage',
    meta: { tag: '料号与批号匹配关系' },
    component: () => import('@/pages/MaterialCodeMatchPage')
  },
  {
    path: '/product-data-sale',
    name: 'productDataSalePage',
    meta: { tag: '产品出货数据' },
    component: () => import('@/pages/ProductDataSalePage')
  },
  {
    path: '/product-data-active',
    name: 'productDataActivePage',
    meta: { tag: '产品激活数据' },
    component: () => import('@/pages/ProductDataActivePage')
  },
  {
    path: '/orderShipCustomerConfirm',
    name: 'orderShipCustomerConfirm',
    meta: { tag: 'pda端收货入库记录' },
    component: () => import('@/pages/OrderShipCustomerConfirmPage')
  }

]

export default repairConfig
